export default ['MagazineViewList', 'ActivityList', 'ActivityListTotals']
